var business = {};
module['exports'] = business;
business.credit_card_numbers = require("./credit_card_numbers");
business.credit_card_expiry_dates = require("./credit_card_expiry_dates");
business.credit_card_types = require("./credit_card_types");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/business/index.js
// module id = 580
// module chunks = 0